import { render, staticRenderFns } from "./BillingHome.vue?vue&type=template&id=bc7611ca&scoped=true"
import script from "./BillingHome.vue?vue&type=script&lang=js"
export * from "./BillingHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7611ca",
  null
  
)

export default component.exports